import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    minHeight: 32,
    width: 324,
    minWidth: 124,
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  title: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24,
    letterSpacing: 0.44,
    color: '#000000',
  },
});

export default styles;
